module.exports = __webpack_public_path__ + "static/media/SEE_LIST.0c0abd30.svg";